import { CustomProjection } from "@visx/geo";
import * as topojson from "topojson-client";
import topology from "../topo.json";
import { localPoint } from "@visx/event";
import classNames from "classnames";
import { geoCentroid } from "@visx/vendor/d3-geo";

export const background = "#f7f5f3";

interface FeatureShape {
  type: "Feature";
  id: string;
  geometry: { coordinates: [number, number][][]; type: "Polygon" };
  properties: { name: string; dma: string };
}

const world = topojson.feature(
  topology as any,
  topology.objects.nielsen_dma as any
) as unknown as {
  type: "FeatureCollection";
  features: FeatureShape[];
};

export const colors: string[] = ["#744DCA", "#3D009C", "#9020FF", "#C630FD"];

const MemoDma = ({
  feature,
  path,
  projection,
  i,
  events,
  width,
  zoom,
  centroid,
  isVisible,
  isSelected,
  onDmaClick,
}: any) => {
  const coords: [number, number] | null = projection(geoCentroid(feature));
  const setZoomCenter = (
    event: React.MouseEvent<SVGPathElement, MouseEvent>
  ) => {
    const point = localPoint(event) || { x: 0, y: 0 };
    const scaleAppliedPoint = zoom.applyInverseToPoint({
      x: centroid[0],
      y: centroid[1],
    });
    // Apply the current zoom transform to the point
    //   zoom.translateTo(point);
    //   zoom.clear();
    //   zoom.center();
    // zoom.translate({z
    //   scale({ scaleX: 1.1, scaleY: 1.1, point });
  };
  return (
    <g
      opacity={isSelected ? 0.9 : 0.1}
      className={classNames("map-feature", isSelected && "selected")}
    >
      <path
        className={classNames(
          "map-feature",
          !isSelected && !isVisible && "hidden"
        )}
        d={path || ""}
        fill={colors[i % colors.length]}
        stroke={background}
        strokeWidth={0.5}
        onClick={(event) => {
          if (events) {
            onDmaClick && onDmaClick(feature.properties.dma.toString());
            setZoomCenter(event);
            //   alert(`Clicked: ${feature.properties.name} (${feature.id})`);
          }
        }}
      />
      <text
        fill="#fff"
        transform={`translate(${coords})`}
        fontSize={Math.max(width / 100, 9)}
        className={isSelected && "visible"}
        textAnchor="middle"
      >
        {feature.id}
      </text>
    </g>
  );
};

export const TerritoryMap = ({
  zoom,
  width,
  selectedDma = [],
  onDmaClick,
  events,
}: {
  zoom: any;
  width: number;
  selectedDma?: string[];
  onDmaClick?: (dma: string) => void;
  events?: boolean;
}) => {
  return (
    <CustomProjection<FeatureShape>
      data={world.features}
      translate={[
        zoom.transformMatrix.translateX,
        zoom.transformMatrix.translateY,
      ]}
      scale={zoom.transformMatrix.scaleX}
    >
      {(mercator) => (
        <g>
          {mercator.features.map(
            ({ feature, path, projection, centroid }, i) => (
              <MemoDma
                isSelected={selectedDma.includes(
                  feature.properties.dma.toString()
                )}
                isVisible={selectedDma.length === 0}
                key={`map-feature-${i}`}
                feature={feature}
                path={path}
                projection={projection}
                i={i}
                width={width}
                events={events}
                zoom={zoom}
                centroid={centroid}
                onDmaClick={onDmaClick}
              />
            )
          )}
        </g>
      )}
    </CustomProjection>
  );
};
